import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgModule,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { SafeUrlPipeModule } from '../../pipes/safe-url.pipe';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { WindowService } from '../../shared/window.service';
import { IFrameSizeEventType } from '../../shared/types/iframe-event-type';
import { InstantJoinEventType } from '../../shared/types/instant-join-event-type';

@Component({
  selector: 'lp2-instant-join-iframe',
  template: `
    <iframe
      #iframe
      *ngIf="instantJoinUrl"
      [src]="instantJoinUrl | safeUrl"
      frameborder="0"
      [attr.aria-hidden]="!height ? 'true' : null"
      [height]="height"
      class="container instant-join-iframe"
      [class.instant-join-iframe--spaced]="height"
    >
    </iframe>
  `,
  styleUrls: ['./instant-join-iframe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstantJoinIframeComponent implements OnInit, OnDestroy {
  @ViewChild('iframe')
  public iframe: ElementRef<HTMLIFrameElement>;

  public instantJoinUrl: string;

  // The embed sizes itself from the HEIGHT event it posts on layout. It must NOT be
  // display:none while waiting for that event: a display:none iframe never lays its
  // document out, so the embedded app can only ever measure 0, posts 0, and we stay
  // hidden forever. Instead the iframe always stays in flow and simply renders 0px
  // tall until a height arrives, which leaves no gap above the banner roulette
  // (:host is a flex column, so the iframe is blockified and adds no baseline space).
  public height = 0;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private cdRef: ChangeDetectorRef,
    private windowService: WindowService
  ) {}

  ngOnInit() {
    const environment = this.oeApp.environment;
    const personId = this.oeAppPersonService.id;

    if (environment && personId) {
      this.instantJoinUrl =
        this.oeApp.webInstantJoinPageHost +
        '?env=' +
        environment +
        '&personId=' +
        personId +
        '&lang=' +
        this.oeAppPersonService.preferredLang;
      this.cdRef.markForCheck();
    }

    window.addEventListener('message', this.handleEvents, false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }

  public handleEvents = ({ data, origin }) => {
    if (!isIFrameSameOrigin(this.oeApp.webInstantJoinPageHost, origin)) {
      return;
    }

    switch (data.type) {
      case IFrameSizeEventType.HEIGHT:
        this.height = data.height;
        this.cdRef.markForCheck();
        break;
      case InstantJoinEventType.INSTANT_JOIN_CLASSROOM:
        this.windowService.openUrl(data.data.classroomUrl);
        break;
    }
  }
}

@NgModule({
  imports: [CommonModule, SafeUrlPipeModule],
  declarations: [InstantJoinIframeComponent],
  exports: [InstantJoinIframeComponent],
})
export class InstantJoinIframeModule {}



// WEBPACK FOOTER //
// ./ts/app/components/instant-join-iframe/instant-join-iframe.component.ts